__turbopack_context__.v({
  "availableToConnectBadge": "PXIq3a_availableToConnectBadge",
  "avatar": "PXIq3a_avatar",
  "avatarWrapper": "PXIq3a_avatarWrapper",
  "content": "PXIq3a_content",
  "detailsSection": "PXIq3a_detailsSection",
  "locationWrapper": "PXIq3a_locationWrapper",
  "outerRing": "PXIq3a_outerRing",
  "positionDetails": "PXIq3a_positionDetails",
  "primaryText": "PXIq3a_primaryText",
  "root": "PXIq3a_root",
  "secondaryText": "PXIq3a_secondaryText",
  "teamName": "PXIq3a_teamName",
  "tertiaryText": "PXIq3a_tertiaryText",
  "top": "PXIq3a_top",
});
